import { store } from '@/store'
import { Equipment, ColorMap } from '@/class'

class Armor extends Equipment {
  private stun_: number
  private block_: number
  private consumable_slots_: number
  private traits_: string[]

  public constructor(name) {
    super(name)
  }

  // ==========================================================
  // GETTERS
  // ==========================================================

  get Block() {
    return this.block_
  }
  get Guard() {
    return this.stun_
  }
  get Header() {
    return this.name_ + ' - ' + this.Category
  }
  get Traits() {
    return this.traits_
  }
  get Summary() {
    return (
      '**_Rarity_:** ' +
      this.Rarity +
      '; **_Guard_:** ' +
      this.Guard +
      '; **_Block_:** ' +
      this.Block +
      '; **_Load_:** ' +
      this.Load +
      '; **_Durability_:** ' +
      this.Durability
    )
  }
  // ==========================================================
  // FORMATTED GETTERS
  // ==========================================================

  get HasDefense() {
    return this.stun_ > 0
  }
  get DefenseHeader() {
    return '**_Block_:** ' + this.stun_
  }
  get HasBlock() {
    return this.block_ > 0
  }
  get HasGuard() {
    return this.Guard > 0
  }
  get HasSlots() {
    return this.consumable_slots_ > 0
  }
  get ArmorSummary() {
    return '**_Block_:** ' + this.block_ + '; **_Guard_:** ' + this.Guard
  }
  get HasTraits() {
    return this.traits_.length > 0
  }
  get TraitsHeader() {
    return '**Traits:** _' + this.traits_.join('_, _') + '_'
  }
  public get Color() {
    return ColorMap.get('Armor')
  }
  // ==========================================================
  // SERIALIZATION
  // ==========================================================
  public static Deserialize(data: IArmorData): Armor {
    const t = new Armor(data.name)
    t.setArmorData(data)
    return t
  }

  public setArmorData(data: IArmorData): void {
    this.setEquipmentData(data)
    this.stun_ = data.guard || 0
    this.block_ = data.block || 0
    this.consumable_slots_ = data.consumable_slots || 0
    this.traits_ = data.traits || []
  }
}
export default Armor
